import React, { useEffect, useState, useLayoutEffect } from 'react';
import './market.css';
import {useLocation, Link} from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import dayjs from 'dayjs';
import Paging from './paging';
import Mpaging from './mpaging';
import Soosang from './soosang';
import Eventy from './events';
import axios from 'axios';
import {keepPreviousData, useQuery} from '@tanstack/react-query';

const Usar=()=>{
    const coco = useLocation();
    const [reshu, setreshu] = useState();
    const [zezu, setzezu] = useState();
    const [sesu, setsesu] = useState();
    const [memu, setmemu] = useState();

 
    const sfnax = async (arry)=>{
        const koka = uggle(arry.chu);         
        const kokb = uggle(arry.zhu);
        const kokc = uggle(arry.shu); 
        const kokd = aggle(arry.shu, arry.events); 
        
        const data = {a :koka, b: kokb, c: kokc, d: kokd};
       
        return data;
    };

    const fnax = async (signal) => {

            const { data : hooko } = await axios.get('/api/carousel', { signal });
            
            const data = {h : vggle(hooko.main), a : uggle(hooko.sub1), b: uggle(hooko.sub2), c: uggle(hooko.sub3), d: aggle(hooko.sub3, hooko.event), e:uggle(hooko.event)};
           
            return data;
        //  return hooko;
       };

     const {isPending, data : last} = useQuery({queryKey:['ka'], queryFn: ({signal})=>fnax(signal), 
     placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30 });

    //  select: (hooko)=>{ 
    //     const data = {a : uggle(hooko.sub1), b: uggle(hooko.sub2), c: uggle(hooko.sub3), d: aggle(hooko.sub3, hooko.event), e:uggle(hooko.event)};   
    //     console.log("여기야윤", data);
    //     return data;}
    // const {isPending, data : last} = useQuery({queryKey:['ka'], queryFn: ()=>fnax(arka), placeholderData: keepPreviousData});
      
//    useLayoutEffect(()=>{
//    // const rshu = shu.sort(()=>Math.random() - 0.5);
//    suggle(arka.chu); 
//    zuggle(arka.zhu);
//    nuggle(arka.shu);
//    muggle(arka.shu, arka.events);
//    console.log("셔풀이다", arka.chu);
//    },[]);

//     useEffect(()=>{
//         const controller = new AbortController();
//         const { signal } = controller;

//         const godda = async ()=>{
//             try{
//             const { data } = await axios.get('/api/carousel', { signal });
//             console.log("이청아다", data);
//         } catch(err){
//             console.log("이처");
//         };
//         };

//         godda();

// return () => controller.abort();
//      },[]);

   const uggle =(shu)=>{
    if(shu.length === 0 || shu === undefined) return shu;
    for (let i = shu.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [shu[i], shu[j]] = [shu[j], shu[i]];
      };
      return shu;
};

const aggle =(a, b = [])=>{
    const ugoka = a.concat(b);
    for (let i = ugoka.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [ugoka[i], ugoka[j]] = [ugoka[j], ugoka[i]];
      };
     return ugoka;
};

   const suggle =(shu)=>{
    for (let i = shu.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [shu[i], shu[j]] = [shu[j], shu[i]];
      };
      setreshu(shu);
};

const zuggle =(shu)=>{
    for (let i = shu.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [shu[i], shu[j]] = [shu[j], shu[i]];
      };
      setzezu(shu);
};

const vggle =(arar)=>{
    if(arar.length === 0) return [{link : "#", image : "hanbok.png", period : "", title : "돌파공모"}];
   
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };
     return arar.length === 2 ? [...arar, {link : "#", image : "hanbok.png", period : "", title : "돌파공모"}] : arar;
};

const nuggle =(shu)=>{
    for (let i = shu.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [shu[i], shu[j]] = [shu[j], shu[i]];
      };
      setsesu(shu);
};

const muggle =(a, b)=>{
    const ugoka = a.concat(b);
    for (let i = ugoka.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [ugoka[i], ugoka[j]] = [ugoka[j], ugoka[i]];
      };
      setmemu(ugoka);
};


const bover = isMobile ? "mover" : "cover";

return(
<>

<div className='market'>
<div className={isMobile ? "mback" : "back"}>
    <h3 className={isMobile ? 'lettaz letp' : 'lettaz'} style={{backgroundImage: `url(${process.env.PUBLIC_URL}/greens.png)`}}>돌파추천</h3>
    <div className='aa'>
        {/* {reshu && reshu.map((con,i)=>{ 
            return (<div className={bover}>
            <Link to={`ajo/${con.link}`} className='wonche' onClick={()=>{ 
                window.history.pushState({nopi : window.scrollY},null,null); 
                window.history.states = {nopi : window.scrollY}; 
                window.history.tates = {nopi : window.scrollY};}}>
            <div className='smallpic'>
            <img src={process.env.PUBLIC_URL+`/document/${con.image}`} />
        
            </div>
            <div className='smallmemo'>
            <p>
                <span className='day'>{reshu && con.online}~{reshu && con.offline}</span>
            </p>
            <p>{reshu && con.title}  <span className='end'>D-{reshu && moment(con.offline).diff(moment().format('YYYY-MM-DD'),'days')}</span></p>
            </div>
            </Link>
            </div>)})} */}
    </div>     
    <div className='aa'>
        {last && last?.a.map((con,i)=>{ 
            return (<div className={bover}>
            <Link to={`ajo/${con.link}`} className='wonche' onClick={()=>{ 
                window.history.pushState({nopi : window.scrollY},null,null); 
                window.history.states = {nopi : window.scrollY}; 
                window.history.tates = {nopi : window.scrollY};}}>
            <div className='smallpic'>
            <img src={process.env.PUBLIC_URL+`/document/${con.image}`} />
              
            </div>
            <div className='smallmemo'>
            <p>
                <span className='day'>{last && dayjs(con.online).format('YYYY.M.D')}~{last && dayjs(con.offline).format('YYYY.M.D')}</span>
            </p>
            <p>{last && con.title}  <span className='end'>D-{last && dayjs(con.offline).startOf('day').diff(dayjs().startOf('day'),'day')}</span></p>
            </div>
            </Link>
            </div>)})}
    </div>    
</div>

<div className={isMobile ? "mback2" : "back2"}>
    <h3 className={isMobile ? 'lettay letp' : 'lettay'} style={{backgroundImage: `url(${process.env.PUBLIC_URL}/yellows.png)`}}>돌파스페셜</h3>
    <div className='aa'>
    {/* {zezu && zezu.map((con,i)=>{ 
            return (<div className={bover}>
            <Link to={`ajo/${con.link}`} className='wonche'>
            <div className='smallpic'>
            <img src={process.env.PUBLIC_URL+`/document/${con.image}`} />
            </div>
            <div className='smallmemo'>
            <p>
                <span className='day'>{zezu && con.online}~{zezu && con.offline}</span>
            </p>
            <p>{zezu && con.title}  <span className='end'>D-{zezu && moment(con.offline).diff(moment().format('YYYY-MM-DD'),'days')}</span></p>
            </div>
            </Link>
            </div>)})}    */}
    </div>    
    <div className='aa'>
    {last && last.b.map((con,i)=>{ 
            return (<div className={bover}>
            <Link to={`ajo/${con.link}`} className='wonche' onClick={()=>{ 
                window.history.pushState({nopi : window.scrollY},null,null); 
                window.history.states = {nopi : window.scrollY}; 
                window.history.tates = {nopi : window.scrollY};}}>
            <div className='smallpic'>
            <img src={process.env.PUBLIC_URL+`/document/${con.image}`} />
            </div>
            <div className='smallmemo'>
            <p>
                <span className='day'>{last && dayjs(con.online).format('YYYY.M.D')}~{last && dayjs(con.offline).format('YYYY.M.D')}</span>
            </p>
            <p>{last && con.title}  <span className='end'>D-{last && dayjs(con.offline).startOf('day').diff(dayjs().startOf('day'),'day')}</span></p>
            </div>
            </Link>
            </div>)})}   
    </div>   
</div>

<div className={isMobile ? 'msoosu' : 'soosu'}>
<h3 className={isMobile ? 'lettaz letp' : 'lettaz'} style={{backgroundImage: `url(${process.env.PUBLIC_URL}/reds.png)`}}>돌파주목</h3>
 <div className={isMobile ? 'soosu1 msoosu1' : 'soosu1'}>
    {isMobile ? <ul className='soosu2'>
    {/* {memu && memu.map((con,i)=>{ 
            return (<li className={isMobile ? "soosu13" : "soosu3"}>
            <Link to={`ajo/${con.link}`} className='soosu4'>
            <div className='soosu5'>
             <div className='soosu6'>
                <img src={process.env.PUBLIC_URL+`/document/${con.image}`} className='soosu7' />
                <span className='zend'>D-{moment(con.offline).diff(moment().format('YYYY-MM-DD'),'days')}</span>
             </div>
             <div className='soosu8'>
               <span className={isMobile ? "soosu11" : "soosu14"}>{con.online}~{moment(con.offline).format('MM.DD')}</span>
                <span className={isMobile ? "soosu9" : "soosu15"}>{con.title}</span>
             </div>
            </div>
            </Link>
            </li>)})}    */}
    {last && last.d.map((con,i)=>{ 
            return (<li className={isMobile ? "soosu13" : "soosu3"}>
            <Link to={`ajo/${con.link}`} className='soosu4' onClick={()=>{ 
                window.history.pushState({nopi : window.scrollY},null,null); 
                window.history.states = {nopi : window.scrollY}; 
                window.history.tates = {nopi : window.scrollY};}}>
            <div className='soosu5'>
             <div className='soosu6'>
                <img src={process.env.PUBLIC_URL+`/document/${con.image}`} className='soosu7' />
                <span className='zend'>D-{dayjs(con.offline).startOf('day').diff(dayjs().startOf('day'),'day')}</span>
             </div>
             <div className='soosu8'>
               <span className={isMobile ? "soosu11" : "soosu14"}>{dayjs(con.online).format('YYYY.M.D')}~{dayjs(con.offline).format('M.D')}</span>
                <span className={isMobile ? "soosu9" : "soosu15"}>{con.title}</span>
             </div>
            </div>
            </Link>
            </li>)})}   
    </ul> : 
    <ul className='soosu2'>
    {/* {sesu && sesu.map((con,i)=>{ 
            return (<li className={isMobile ? "soosu13" : "soosu3"}>
            <Link to={`ajo/${con.link}`} className='soosu4'>
            <div className='soosu5'>
             <div className='soosu6'>
                <img src={process.env.PUBLIC_URL+`/document/${con.image}`} className='soosu7' />
                <span className='zend'>D-{moment(con.offline).diff(moment().format('YYYY-MM-DD'),'days')}</span>
             </div>
             <div className='soosu8'>
               <span className={isMobile ? "soosu11" : "soosu14"}>{con.online}~{con.offline}</span>
                <span className={isMobile ? "soosu9" : "soosu15"}>{con.title}</span>
             </div>
            </div>
            </Link>
            </li>)})}    */}
    {last && last.c.map((con,i)=>{ 
            return (<li className={isMobile ? "soosu13" : "soosu3"}>
            <Link to={`ajo/${con.link}`} className='soosu4' onClick={()=>{ 
                window.history.pushState({nopi : window.scrollY},null,null); 
                window.history.states = {nopi : window.scrollY}; 
                window.history.tates = {nopi : window.scrollY};}}>
            <div className='soosu5'>
             <div className='soosu6'>
                <img src={process.env.PUBLIC_URL+`/document/${con.image}`} className='soosu7' />
                <span className='zend'>D-{dayjs(con.offline).startOf('day').diff(dayjs().startOf('day'),'day')}</span>
             </div>
             <div className='soosu8'>
               <span className={isMobile ? "soosu11" : "soosu14"}>{dayjs(con.online).format('YYYY.M.D')}~{dayjs(con.offline).format('YYYY.M.D')}</span>
                <span className={isMobile ? "soosu9" : "soosu15"}>{con.title}</span>
             </div>
            </div>
            </Link>
            </li>)})}   
    </ul>
    }
 </div>
{isMobile ? <div style={{display:"none"}}></div> :
  <div className='susaz'>
    <div className='susaz1'><p className='susaz4'>수상 소식을 기록해보세요!</p>
    <Link to='/hika' className='aheri zonn'>
    <span className='pcan'>+</span>
    </Link>
    <Soosang/>
    </div>
    <div className='susaz2'>
        <Eventy prefect={last?.e}/>
    </div>
    {/* <div className='susaz3'><p>이벤트고정</p></div> */}
 </div>
}          
</div>

</div>
{isMobile ? <Mpaging/> : <Paging />}
</>
);
}

export default Usar;